import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/Save';

export default function SaveButton({
  label,
  onClick,
  sx,
  type = 'submit',
  variant = 'contained',
  color = 'success',
}) {
  const sxDefault = {
    margin: 1,
    ...sx,
  };

  return (
    <Button
      type={type}
      variant={variant}
      color={color}
      onClick={onClick}
      startIcon={<SaveIcon />}
      sx={sxDefault}
    >
      {label}
    </Button>
  );
}

SaveButton.propTypes = {
  label: PropTypes.string.isRequired,
};
